// cSpell:enableCompoundWords
import { updateFbSqUser } from 'api/UserAPI';
import Box from 'components/box/Box';
import EditableField from 'components/editablefield/EditableField';
import IconButton from 'components/iconbutton/IconButton';
import GhostIcon from 'components/icons/svg/GhostIcon';
import LabeledField from 'components/labeledfield/LabeledField';
import ModalTitle from 'components/modal/components/modaltitle/ModalTitle';
import Ruler from 'components/ruler/Ruler';
import { useAppDispatch, useAppSelector } from 'hooks/hooks';
import React, { useState } from 'react';
import { ModalKind, setModal } from 'slices/SqModalSlice';
import { doLogoutUser, getFbSqUser, getName } from 'slices/SqUserSlice';
import { ASComponentSize } from 'types/App.types';
import styles from './UserSettings.module.scss';
import { RulerType } from 'constants/constants';

type UserSettingsProps = {
  className?: string;
};

const UserSettings: React.FC<UserSettingsProps> = ({ className = '' }) => {
  const baseCls = `${styles.UserSettings} ${className}`;
  const name = useAppSelector(getName);
  const user = useAppSelector(getFbSqUser);

  const dispatch = useAppDispatch();

  const [userName, setUserName] = useState<string>(name);

  const onUserNameChanged = (value: string) => {
    updateFbSqUser({ ...user!, name: value.trim() });
    setUserName(value.trim());
  };

  const onLogout = () => {
    dispatch(setModal({ kind: ModalKind.ShowUserSettingsModal, isVisible: false }));
    dispatch(doLogoutUser());
  };

  return (
    <div className={`${baseCls} ${styles.TopMarginSpacer}`}>
      <ModalTitle>USER SETTINGS</ModalTitle>

      <Box style={{ width: '-webkit-fill-available', gap: '32px' }}>
        <LabeledField labelSize={50} cmpStyle={{ maxWidth: '320px' }} fieldLabel="EMAIL">
          <span className={styles.UserSettingsEmail}>{user?.email}</span>
        </LabeledField>
        <LabeledField labelSize={50} cmpStyle={{ maxWidth: '320px' }} fieldLabel="NAME">
          <EditableField
            name="user name"
            minLength={2}
            maxLength={11}
            style={{ width: '150px' }}
            fieldValue={userName}
            onFieldChange={onUserNameChanged}
            className={styles.UserSettingsName}
          />
        </LabeledField>
      </Box>

      <Ruler className={RulerType.MODAL_SEPARATOR_THIN} />

      <IconButton
        size={ASComponentSize.Medium}
        style={{ color: '#ff1b1b', alignSelf: 'center' }}
        withText
        onClick={onLogout}
      >
        <GhostIcon color="#ff1b1b" size={30} />
        LOGOUT
      </IconButton>
    </div>
  );
};

export default UserSettings;
